import type { Step } from "react-joyride";

export const otRuleDetailTourSteps: Step[] = [
  {
    target: "body",
    content:
      "ຫນ້ານີ້ໃຊ້ເບິ່ງລາຍລະອຽດຂໍ້ກຳນົດ OT. ສາມາດແກ້ໄຂຈາກປຸ່ມດ້ານເທິງ.",
    placement: "center",
    disableBeacon: true,
  },
  {
    target: '[data-tourid="ot-rule-detail-back"]',
    content: "ກັບໄປລາຍການຂໍ້ກຳນົດ OT ຫຼື ແກ້ໄຂຂໍ້ກຳນົດນີ້.",
    placement: "bottom",
  },
  {
    target: '[data-tourid="ot-rule-detail-card"]',
    content: "ຂໍ້ມູນຂໍ້ກຳນົດ: ຊື່, ປະເພດວັນ, ອັດຕາຄູນ, ວັນທີ່ມີຜົນ, ສະຖານະ.",
    placement: "top",
  },
];
